import User from "@views/user/User";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      title: "个人中心",
      keepAlive: true,
      footer: true,
      auth: true
    },
    component: User
  },
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "绑定手机",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/BindingPhone.vue")
  },
  {
    path: "/user/add_address/:id?",
    name: "AddAddress",
    meta: {
      title: "添加收货地址",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddAddress.vue")
  },
  {
    path: "/user/account",
    name: "UserAccount",
    meta: {
      title: "我的账户",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserAccount.vue")
  },
  {
    path: "/user/balance",
    name: "UserBlanace",
    meta: {
      title: "消费券余额互转",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserBlanace.vue")
  },
  {
    path: "/user/balance/xfq",
    name: "BlanaceXfq",
    meta: {
      title: "消费券余额转消费券",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/BlanaceXfq.vue")
  },
  {
    path: "/user/xfq/ye",
    name: "XfqYe",
    meta: {
      title: "消费券转消费券余额",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/XfqYe.vue")
  },
  {
    path: "/user/spread_award",
    name: "spreadAward",
    meta: {
      title: "推广专区",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/SpreadAward.vue")
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddressManagement.vue")
  },
  {
    path: "/user/poster",
    name: "Poster",
    meta: {
      title: "分销海报",
      keepAlive: false,
      backgroundColor: "#a3a3a3",
      auth: true
    },
    component: () => import("@views/user/promotion/Poster.vue")
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "签到",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Sign.vue")
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "签到记录",
      keepAlive: true
    },
    component: () => import("@views/user/signIn/SignRecord.vue")
  },
  {
    path: "/user/cash",
    name: "UserCash",
    meta: {
      title: "提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/user/merchant",
    name: "merchant",
    meta: {
      title: "商家打赏",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/merchant.vue")
  },
  {
    path: "/user/pai/deal",
    name: "paiDeal",
    meta: {
      title: "信商资产划转",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/paiDeal.vue")
  },
  {
    path: "/user/pai/statistics",
    name: "paiStatistics",
    meta: {
      title: "信商资产统计",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/paiStatistics.vue")
  },
  {
    path: "/user/order/count",
    name: "orderCount",
    meta: {
      title: "订单统计",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/orderCount.vue")
  },
  {
    path: "/user/agent/count",
    name: "agentCount",
    meta: {
      title: "商城奖励",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/AgentCount.vue")
  },
  {
    path: "/user/promotion/count",
    name: "promotionCount",
    meta: {
      title: "促销专区奖励",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromotionCount.vue")
  },
  {
    path: "/user/day/count",
    name: "dayCount",
    meta: {
      title: "消费达标奖励",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/dayCount.vue")
  },
  {
    path: "/user/all_record",
    name: "allCount",
    meta: {
      title: "奖励记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/allCount.vue")
  },
  {
    path: "/user/business_record",
    name: "businessRecord",
    meta: {
      title: "商务分红",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/businessRecord.vue")
  },
  {
    path: "/user/recommend_merchants",
    name: "recommendMerchants",
    meta: {
      title: "推荐商家分红",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/recommendMerchants.vue")
  },
  {
    path: "/user/recommend_merchants",
    name: "recommendMerchants",
    meta: {
      title: "推广员",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/recommendMerchants.vue")
  },
  {
    path: "/user/majordomo/count",
    name: "majordomoCount",
    meta: {
      title: "市场总监统计",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/MajordomoCount.vue")
  },
  {
    path: "/user/audit",
    name: "CashAudit",
    meta: {
      title: "提现审核",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashAudit.vue")
  },
  {
    path: "/user/promoter_order",
    name: "PromoterOrder",
    meta: {
      title: "推广人订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterOrder.vue")
  },
  {
    path: "/user/merchant_order",
    name: "MerchantOrder",
    meta: {
      title: "商家订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/MerchantOrder.vue")
  },
  {
    path: "/user/voucher_send",
    name: "voucherSend",
    meta: {
      title: "消费券发放",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/voucherSend.vue")
  },
  {
    path: "/user/voucher_count",
    name: "voucherCount",
    meta: {
      title: "消费券统计",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/voucherCount.vue")
  },
  {
    path: "/user/voucher_use",
    name: "merchantVoucher",
    meta: {
      title: "消费券使用",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/merchantVoucher.vue")
  },
  {
    path: "/user/user_consumption_voucher",
    name: "userVoucherUse",
    meta: {
      title: "用户余额消费券明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/userVoucherUse.vue")
  },
  {
    path: "/user/user_voucher_detail",
    name: "userVoucherDetail",
    meta: {
      title: "用户余额消费券明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/userVoucherDetail.vue")
  },
  {
    path: "/user/merchant_spread",
    name: "MerchantSpread",
    meta: {
      title: "推荐商家",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/spreadMerchant.vue")
  },
  {
    path: "/user/promoter_list",
    name: "PromoterList",
    meta: {
      title: "推广人列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterList.vue")
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "我的推广",
      keepAlive: true,
      auth: true,
      // level: true
    },
    component: () => import("@views/user/promotion/UserPromotion.vue")
  },
  {
    path: "/user/bill/:types?",
    name: "UserBill",
    meta: {
      title: "账单明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserBill.vue")
  },
  {
    path: "/user/multiple/:types?",
    name: "UserMultiple",
    meta: {
      title: "消费奖励明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserMultiple.vue")
  },
  {
    path: "/user/cashrecord",
    name: "CashRecord",
    meta: {
      title: "提现记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashRecord.vue")
  },
  {
    path: "/user/commission",
    name: "CommissionDetails",
    meta: {
      title: "佣金明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionDetails.vue")
  },
  {
    path: "/user/integral",
    name: "Integral",
    meta: {
      title: "积分详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Integral.vue")
  },
  {
    path: "/user/integral_ordinary",
    name: "IntegralOrdinary",
    meta: {
      title: "积分详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/IntegralOrdinary.vue")
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "会员中心",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserVip.vue")
  },
  {
    path: "/user/company",
    name: "UserCompany",
    meta: {
      title: "公司业务",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserCompany.vue")
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "个人资料",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/PersonalData.vue")
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的优惠券",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/coupon/UserCoupon.vue")
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "领取优惠券",
      keepAlive: true
    },
    component: () => import("@views/user/coupon/GetCoupon.vue")
  },
  {
    path: "/user/user_cash",
    name: "UserCash",
    meta: {
      title: "申请提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/customer/list",
    name: "CustomerList",
    meta: {
      title: "客服列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/CustomerList.vue")
  },
  {
    path: "/user/Recharge",
    name: "Recharge",
    meta: {
      title: "消费券充值",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Recharge.vue")
  },
  {
    path: "/user/promoter_rank",
    name: "PromoterRank",
    meta: {
      title: "推广人排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterRank.vue")
  },
  {
    path: "/user/commission/rank",
    name: "CommissionRank",
    meta: {
      title: "佣金排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionRank.vue")
  },
  {
    path: "/user/baoxian",
    name: "Baoxian",
    meta: {
      title: "保险项目",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/BaoXian.vue")
  },
  {
    path: "/user/peigu",
    name: "UserPeiGu",
    meta: {
      title: "用户配股",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/PeiGu.vue")
  },
  {
    path: "/user/yikangbao",
    name: "Yikangbao",
    meta: {
      title: "通证积分",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Yikangbao.vue")
  },
  {
    path: "/user/wx_login",
    name: "WxLogin",
    meta: {
      title: "我的推广",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/WxLogin.vue")
  },
  {
    path: "/user/user_mill",
    name: "UserMill",
    meta: {
      title: "矿机推广",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/mill/UserMill.vue")
  },
  {
    path: "/user/commission_mill",
    name: "CommissionMills",
    meta: {
      title: "推广币明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/mill/CommissionMills.vue")
  },
  {
    path: "/user/mill_cash",
    name: "MillCash",
    meta: {
      title: "申请提币",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/mill/MillCash.vue")
  },
  {
    path: "/mill/audit",
    name: "MillAudit",
    meta: {
      title: "提现审核",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/mill/MillAudit.vue")
  },
  {
    path: "/user/pai",
    name: "PaiList",
    meta: {
      title: "信商资产记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/Pai.vue")
  },
  {
    path: "/user/pai/info",
    name: "PaiInfo",
    meta: {
      title: "参与信商资产分配信息",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PaiInfo.vue")
  },
  {
    path: "/user/apply_merchant",
    name: "ApplyMerchant",
    meta: {
      title: "申请商家",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/ApplyMerchant.vue")
  },
];
